module.exports = __webpack_public_path__ + "img/baixar-app-ios.2f0b8635.gif";